import React from 'react'
import SuppliersFilterQuery from './fields/SuppliersFilterQuery'

const SuppliersFilters = () => {
  return (
    <div className='myBlock__filtersOptions'>
        <SuppliersFilterQuery />
    </div>
  )
}

export default SuppliersFilters